import PropTypes from "prop-types";
import "../../dashboard-cme/dashboard-cme.scss";
import React, { useState, useEffect } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { getBookedVacationTooltip, getDateColor, getLastUpdatedTootlTip, useSortableData } from "../../dashboard-util/dashboard-utils";
import ArrowDown from "../../../../assets/icons/ArrowDown.svg";
import ArrowUp from "../../../../assets/icons/ArrowUp.svg";
import ArrowHover from "../../../../assets/icons/ArrowHover.svg";
import ViolationIcon from "../../../../assets/icons/Icon-Complete-56px-Gold-50.svg";
import { CMEAvailableCapacity, CMEPrevWeekend, CMEWorkload } from "../cme-util/cme-utils";
import CMEProjectModal from "./cme-project-modal";
import CMEVacationModal from "./cme-vacations-modal";
import { GetCMEMemberTimeLogExcelExport } from "../../../../services/api/dashboard-api";
import { DashboardExport } from "../../../../assets/icons";
import { getInitials } from "../../../../util/general-helpers";

const CMEMemberTimeLog = (props) => {
    const [members, setMembers] = useState(props.items ? props.items : null);
    const [show, setShow] = useState(false);
    const [showVacation, setShowVacation] = useState(false);
    const [selectedMember, setSelectedMember] = useState(null);
    const { items, requestSort, getArrowDirectionFor } = useSortableData(members);

    useEffect(() => {
        if (props.items) setMembers(props.items);
    }, [props]);

    const showModal = (m) => {
        setShow(true);
        setSelectedMember(m)
    }

    const onHide = () => {
        setShow(false);
        setSelectedMember(null)
    }

    const showModalVacation = (m) => {
        setShowVacation(true);
        setSelectedMember(m)
    }

    const onHideVacation = () => {
        setShowVacation(false);
        setSelectedMember(null)
    }

    const renderMemberTable = (memberList) => {
        return (
            <div className="scrollable-dashboard">
            <table className="CMEDashboardTable">
                <thead className="MemberTableColumnHeader cmeHeader sticky-header-dashboard">
                    <tr className="tableColumnTitles tableHeader">
                        <th className="col-md-1 col-sm-1 textEllipsis headerSorted">
                            <div onClick={() => requestSort("AnalystAssociate")} className={'sortedCenter'}>
                                <div className="containerTextSorted">
                                    <p className="textSorted">Analyst/Associate</p>
                                </div>
                                {
                                    getArrowDirectionFor("AnalystAssociate", "descending") && (
                                        <img className="arrowDirection" alt="Arrow down" src={ArrowDown} />
                                    )
                                }
                                {
                                    getArrowDirectionFor("AnalystAssociate", "ascending") && (
                                        <img className="arrowDirection" alt="Arrow up" src={ArrowUp} />
                                    )
                                }
                                {
                                    getArrowDirectionFor("AnalystAssociate") && (
                                        <img className="arrowDirectionHover" alt="Arrow sort" src={ArrowHover} />
                                    )
                                }
                            </div>
                        </th>
                        <th className="col-md-1 col-sm-1 textEllipsis headerSorted">Overall Workload</th>
                        <th className="col-md-1 col-sm-1 textEllipsis headerSorted">Estimated Available Capacity</th>
                        <th className="col-md-1 col-sm-1 textEllipsis headerSorted">Worked Previous Weekend</th>

                        <th className="col-md-1 col-sm-1 textEllipsis headerSorted">M-F Hours</th>
                        <th className="col-md-1 col-sm-1 textEllipsis headerSorted">Saturday Hours</th>
                        <th className="col-md-1 col-sm-1 textEllipsis headerSorted">Sunday Hours</th>
                        <th className="col-md-1 col-sm-1 textEllipsis headerSorted">Total Hours</th>
                        {getBookedVacationTooltip(<th className="col-md-1 col-sm-1 textEllipsis headerSorted">Vacation/PTO</th>)}
                        {getLastUpdatedTootlTip(<th className="col-md-1 col-sm-1 textEllipsis headerSorted">Last Updated</th>)}
                    </tr>
                </thead>
                <tbody className="tableBody cmeBody">
                    {memberList.length > 0 &&
                        memberList.map((pm) => {
                            return (
                                <tr key={pm?.UserId} className={pm?.IsViolation ? "isViolation" : ""}>
                                    <td className="col-md-1 col-sm-1 mt-2 hover" onClick={() => { showModal(pm) }}>
                                        <div className="violationContainer">
                                            <div className="violationIconContainer">
                                                {
                                                    pm?.IsViolation ?
                                                        <OverlayTrigger
                                                            placement={"bottom-start"}
                                                            delay={{ show: 150, hide: 150 }}
                                                            overlay={
                                                                <Tooltip>
                                                                    Violation
                                                                </Tooltip>
                                                            }>
                                                            <img className="violationIcon" src={ViolationIcon}>
                                                            </img>
                                                        </OverlayTrigger>
                                                        :
                                                        <div className={`member-icon-user d-flex align-items-center`}>
                                                            <div className={`member-icon-initials-user`}>{getInitials(pm.AnalystAssociate)}</div>
                                                        </div>
                                                }
                                            </div>
                                            {pm.AnalystAssociate}
                                        </div>
                                    </td>
                                    <td className="col-md-1 col-sm-1 mt-2">
                                        <CMEWorkload workload={pm.OverAllWorkload} />
                                    </td>
                                    <td className="col-md-1 col-sm-1 mt-2">
                                        <CMEAvailableCapacity capacity={pm.EstAvailableCapacity} />
                                    </td>
                                    <td className="col-md-2 col-sm-2 mt-2">
                                        <CMEPrevWeekend weekend={pm.WorkedPreviousWeekend} />
                                    </td>
                                    <td className="col-md-1 col-sm-1 mt-2">
                                        {pm.AggregateMFHours}
                                    </td>
                                    <td className="col-md-1 col-sm-1 mt-2">
                                        {pm.AggregateSaturdayHours}
                                    </td>
                                    <td className="col-md-1 col-sm-1 mt-2">
                                        {pm.AggregateSundayHours}
                                    </td>
                                    <td className="col-md-1 col-sm-1 mt-2">
                                        {pm.AggregateTotalHours}
                                    </td>
                                    <td className="col-md-1 col-sm-1 mt-2 hover" style={{ color: getDateColor(pm.VacationPtoColor) }}
                                        onClick={() => {
                                            if (pm?.TableVacation[0]?.Rows.length > 0 || pm?.TableProtected[0]?.Rows.length > 0)
                                                showModalVacation(pm)
                                        }}>
                                        {pm.VacationPto}
                                    </td>
                                    <td className="col-md-1 col-sm-1 mt-2">
                                        {pm.LastUpdated}
                                    </td>                                    
                                </tr>
                            );
                        })}
                </tbody>
            </table>
            {selectedMember &&
                <CMEProjectModal
                    item={selectedMember} fetchData={props.fetchData} show={show} onHide={onHide}>
                </CMEProjectModal>
            }

            {selectedMember &&
                <CMEVacationModal
                    item={selectedMember} show={showVacation} onHide={onHideVacation} >
                </CMEVacationModal>}
            </div>
        )
    }

    return (
        <div className="new-dashboard table-wrapper mt-4">
            <div className="DashboardTableWrapper CMEDashboard">
                <div>
                    <div className="DashboardTableHeader">
                        <th className="DashboardTableTitle">
                            Member Time Log
                            <div className="DashboardTableHeaderButtons">
                                <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Export Data</Tooltip>}
                                >
                                    <img src={DashboardExport} onClick={GetCMEMemberTimeLogExcelExport} alt="Export CME"/>
                                </OverlayTrigger>
                            </div>
                            <div className="subDepartmentTitle">GIB/CME</div>
                        </th>
                    </div>
                </div>
                {items?.length > 0 && renderMemberTable(items)}
            </div>
        </div>
    );
};

CMEMemberTimeLog.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
          UserId: PropTypes.number.isRequired,
          AnalystAssociate: PropTypes.string.isRequired,
          OverAllWorkload: PropTypes.string.isRequired,
          EstAvailableCapacity: PropTypes.string.isRequired,
          WorkedPreviousWeekend: PropTypes.string.isRequired,
          AggregateMFHours: PropTypes.string.isRequired,
          AggregateSaturdayHours: PropTypes.string.isRequired,
          AggregateSundayHours: PropTypes.string.isRequired,
          AggregateTotalHours: PropTypes.string.isRequired,
          VacationPto: PropTypes.string.isRequired,
          VacationPtoColor: PropTypes.string.isRequired,
          LastUpdated: PropTypes.string.isRequired,
          IsViolation: PropTypes.bool.isRequired,
          TableVacation: PropTypes.arrayOf(PropTypes.shape({
            Columns: PropTypes.arrayOf(PropTypes.shape({
                Id: PropTypes.number.isRequired,
                Name: PropTypes.string.isRequired
            })).isRequired,
            Rows: PropTypes.arrayOf(PropTypes.shape({
                Id: PropTypes.number.isRequired,
                Row: PropTypes.number.isRequired,
                Data: PropTypes.arrayOf(PropTypes.shape({
                    Id: PropTypes.number.isRequired,
                    Value: PropTypes.string.isRequired
                })).isRequired
            })).isRequired
        })),
        TableProtected: PropTypes.arrayOf(PropTypes.shape({
            Columns: PropTypes.arrayOf(PropTypes.shape({
                Id: PropTypes.number.isRequired,
                Name: PropTypes.string.isRequired
            })).isRequired,
            Rows: PropTypes.arrayOf(PropTypes.shape({
                Id: PropTypes.number.isRequired,
                Row: PropTypes.number.isRequired,
                Data: PropTypes.arrayOf(PropTypes.shape({
                    Id: PropTypes.number.isRequired,
                    Value: PropTypes.string.isRequired
                })).isRequired
            })).isRequired
        })),
          MemberProjects: PropTypes.arrayOf(PropTypes.shape({
            ProjectDynamicFields: PropTypes.arrayOf(PropTypes.shape({
                Label: PropTypes.string.isRequired,
                Value: PropTypes.string.isRequired
            })).isRequired,
            ProjectName: PropTypes.string.isRequired,
            Members: PropTypes.string.isRequired,
            Workload: PropTypes.string.isRequired,
            MFHours: PropTypes.string.isRequired,
            SaturdayHours: PropTypes.string.isRequired,
            SundayHours: PropTypes.string.isRequired,
            TotalHours: PropTypes.string.isRequired
        })).isRequired,
        ProjectDynamicFields: PropTypes.arrayOf(PropTypes.shape({
            Label: PropTypes.string.isRequired,
            Value: PropTypes.string.isRequired
        })).isRequired
        })
      ),
    fetchData: PropTypes.func,
};

export default CMEMemberTimeLog;
